import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatTableDataSource, MatSnackBar } from '@angular/material';
import { FormGroup, FormControl, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { Handle } from '../../../handle';
import { GatewayService } from 'src/app/gateway.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Md5 } from 'ts-md5/dist/md5';
import { LocalSaveService } from 'src/app/services/local-save-service.service';

@Component({
  selector: 'app-create-area',
  templateUrl: './create-area.component.html',
  styleUrls: ['./create-area.component.scss']
})
export class CreateAreaComponent implements OnInit {

  displayedColumns = ['NOMBRE', 'DESCRIPCION', 'BORRAR'];

  listaSub = [];
  dataSource;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private localSave: LocalSaveService,
    private dialogRef: MatDialogRef<CreateAreaComponent>, public Handle: Handle, private spinner: NgxSpinnerService,
    private snackbar: MatSnackBar, private gateway: GatewayService) { }
  operacion = 'createarea';
  idarea = '';
  idpais;

  ngOnInit() {
    this.idpais = this.data.area.IDPAIS;
    if (this.data.operacion == 'Editar') {
      let SUBS = {
        IDAREA: this.data.area.idarea
      }
      this.operacion = 'editarea';
      this.idarea = this.data.area.idarea;
      this.grupoVal.controls.NOMBRE.setValue(this.data.area.nombre);
      this.grupoVal.controls.DESCRIPCION.setValue(this.data.area.descripcion);
    }
  }

  onNoClick() {
    this.dialogRef.close(false);
  }

  save() {
    let md5 = new Md5();
    this.spinner.show();
    let AREA = {
      IDAREA: this.idarea,
      NOMBRE: this.grupoVal.controls.NOMBRE.value.trim(),
      DESCRIPCION: this.grupoVal.controls.DESCRIPCION.value,
      IDPAIS: this.idpais,
      IDSUPADMIN: this.localSave.get('usuarioPGV').IDU
    }

    // console.log('========')
    //   console.log(this.operacion)
    // console.log(AREA)
    //   console.log('/=/=======')
    this.gateway.save(this.operacion, AREA).then((result) => {
      // console.log('========')
      // console.log(result)
      // console.log('/=/=======')
      this.spinner.hide();
      this.dialogRef.close(true);
    }
    ).catch(function (e) {
    });
  }

  grupoVal = new FormGroup({
    NOMBRE: new FormControl('', [Validators.compose([
      Validators.required, Validators.minLength(2), Validators.maxLength(30),
      Validators.pattern("[/ a-z A-Z ñÑáéíóúÁÉÍÓÚ]+[0-9a-z A-Z ñÑáéíóúÁÉÍÓÚ]+")
    ])]),
    DESCRIPCION: new FormControl('',[])
  });

}
